import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  IconButton,
  Collapse,
  Tooltip,
  TextField,
  FormControlLabel
} from '@mui/material';
import {
  CompareArrows as CompareArrowsIcon,
  ContentCopy as CopyIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  Check as CheckIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  Edit as EditIcon
} from '@mui/icons-material';
import config from "../../env.json"

interface Vault {
  name: string;
  Id: number;
  Client_Id: number;
  ClientRsKeyVault_Nm: string;
  CommonKeyVault_Nm: string;
  value?: string; // for missing secret value
  firstValue?: string; // for different secrets current value
  secondValue?: string; // for different secrets new value
}

interface ComparisonResult {
  missingSecrets: string[];
  differentSecrets: string[];
  sourceVault: string;
  targetVault: string;
}

interface MigrationState {
  selectedMissing: string[];
  selectedDifferent: string[];
  isMigrating: boolean;
  isExpanded: boolean;
}

const MigrationToolEnv: any = (data: any) => {
  const { sourceVault, targetVault, sourceVaultId, targetVaultId } = data
  const [vaults, setVaults] = useState<Vault[]>([]);
  const [missingvaults, setMissingVaults] = useState<Vault[]>([]);
  const [differentVaults, setDifferentVaults] = useState<Vault[]>([]);
  const [comparisonResult, setComparisonResult] = useState<ComparisonResult | null>(null);
  const [viewedSecrets, setViewedSecrets] = useState<{ [key: string]: boolean }>({});
  const [editingMissingSecret, setEditingMissingSecret] = useState<string | null>(null);
  const [inlineMissingValue, setInlineMissingValue] = useState<string>('');

  const handleStartMissingEdit = (secretName: string) => {
    const keypair: any = missingvaults.find(item => item.name === secretName);
    setInlineMissingValue(keypair?.value || '');
    setEditingMissingSecret(secretName);
  };

  const handleCancelMissingEdit = () => {
    setEditingMissingSecret(null);
    setInlineMissingValue('');
  };

  const handleUpdateMissingSecret = () => {
    if (!editingMissingSecret) return;
    setMissingVaults(prev =>
      prev.map(item =>
        item.name === editingMissingSecret ? { ...item, value: inlineMissingValue } : item
      )
    );
    setEditingMissingSecret(null);
    setInlineMissingValue('');
  };
  const [migrationState, setMigrationState] = useState<MigrationState>({
    selectedMissing: [],
    selectedDifferent: [],
    isMigrating: false,
    isExpanded: true
  });

  const toggleViewSecret = (secretName: string) => {
    setViewedSecrets(prev => ({
      ...prev,
      [secretName]: !prev[secretName]
    }));
  };

  const compareVaults = async () => {
    console.log("------------>", sourceVault, targetVault, sourceVaultId, targetVaultId)
    // if (!sourceVault || !targetVault || !sourceVaultId || !targetVaultId) {
    //   console.log("------------> 2")
    //   return;
    // }

    setComparisonResult(null);
    console.log("------------> 3")
    try {
      const response = await axios.post(
        config.REACT_APP_ENV_API_BASE + `/KeyvaultControl/migrateVaultAdmin?firstVaultNm=${sourceVault}&SecondVaultNm=${targetVault}`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('login')}`,
          },
        }
      );
      let newResponse = response?.data?.data;

      const mockComparison: ComparisonResult = {
        sourceVault: sourceVault,
        targetVault: targetVault,
        missingSecrets: newResponse?.MissingKeys.map((item: { name: any; }) => item.name) || [],
        differentSecrets: newResponse?.DifferentKeys.map((item: { name: any; }) => item.name) || []
      };

      console.log('Mock comparison result:', mockComparison);
      setMissingVaults(newResponse?.MissingKeys || []);
      setDifferentVaults(newResponse?.DifferentKeys || []);
      setComparisonResult(mockComparison);
    } catch (error: any) {
      console.error('Comparison failed:', error);
    }
  };

  useEffect(() => {
    console.log("------------> 1")
    compareVaults();
  }, []);

  const handleMigrateSelected = async () => {
    if (!comparisonResult) return;

    const { selectedMissing, selectedDifferent } = migrationState;
    if (selectedMissing.length === 0 && selectedDifferent.length === 0) {
      return;
    }

    setMigrationState(prev => ({ ...prev, isMigrating: true }));

    try {
      const { selectedMissing, selectedDifferent } = migrationState;
      const vaultId = vaults.find(v => v.ClientRsKeyVault_Nm === targetVault)?.Id;

      if (!vaultId) {
        throw new Error('Target vault not found');
      }

      // Process missing secrets (they only exist in source)
      for (const secretName of selectedMissing) {
        try {
          // In a real implementation, get the actual secret value from the source vault
          const keypair: any = missingvaults.find(item => item.name === secretName);
          console.log("line190", keypair);
          const secretValue = keypair?.value; // Replace with actual API call

          const payload = {
            VaultData: [{
              name: secretName,
              value: secretValue
            }],
            VaultNm: targetVault,
          };

          await axios.post(
            config.REACT_APP_ENV_API_BASE + '/KeyvaultControl/postKeyVaultAdmin',
            payload,
            {
              headers: {
                'Content-Type': 'application/json',
                // Add other headers here if needed, e.g. Authorization
                'Authorization': `Bearer ${sessionStorage.getItem('login')}`,
              },
            }
          );
        } catch (error) {
          console.error(`Failed to migrate secret ${secretName}:`, error);
          throw new Error(`Failed to migrate secret: ${secretName}`);
        }
      }

      // Process different secrets (update existing in target)
      for (const secretName of selectedDifferent) {
        try {
          // In a real implementation, get the actual secret value from the source vault
          const keypair: any = differentVaults.find(item => item.name === secretName);
          console.log("line190", keypair);
          const secretValue = keypair?.firstValue; // Replace with actual API call

          const payload = {
            VaultData: [{
              name: secretName,
              value: secretValue
            }],
            VaultNm: targetVault,
          };

          await axios.post(
            config.REACT_APP_ENV_API_BASE + '/KeyvaultControl/postKeyVaultAdmin',
            payload,
            {
              headers: {
                'Content-Type': 'application/json',
                // Add other headers here if needed, e.g. Authorization
                'Authorization': `Bearer ${sessionStorage.getItem('login')}`,
              },
            }
          );
        } catch (error) {
          console.error(`Failed to update secret ${secretName}:`, error);
          throw new Error(`Failed to update secret: ${secretName}`);
        }
      }
      // Refresh comparison results after migration
      await compareVaults();
    } catch (error) {
      console.error('Migration failed:', error);
    } finally {
      setMigrationState(prev => ({
        ...prev,
        isMigrating: false,
        selectedMissing: [],
        selectedDifferent: []
      }));
    }
  };

  const handleSelectAll = (type: 'missing' | 'different', checked: boolean) => {
    if (!comparisonResult) return;

    const secrets = type === 'missing'
      ? comparisonResult.missingSecrets
      : comparisonResult.differentSecrets;

    setMigrationState(prev => ({
      ...prev,
      selectedMissing: type === 'missing' && checked ? [...secrets] : [],
      selectedDifferent: type === 'different' && checked ? [...secrets] : []
    }));
  };

  const handleSelectSecret = (type: 'missing' | 'different', secret: string, checked: boolean) => {
    const key = type === 'missing' ? 'selectedMissing' : 'selectedDifferent';
    setMigrationState(prev => ({
      ...prev,
      [key]: checked
        ? [...prev[key as keyof MigrationState] as string[], secret]
        : (prev[key as keyof MigrationState] as string[]).filter(s => s !== secret)
    }));
  };

  const toggleExpand = () => {
    setMigrationState(prev => ({ ...prev, isExpanded: !prev.isExpanded }));
  };

  const handleMigrate = async () => {
    if (!sourceVault || !targetVault || !sourceVaultId || !targetVaultId) {
      return;
    }

    try {
      console.log(`Migrating from ${sourceVault} (ID: ${sourceVaultId}) to ${targetVault} (ID: ${targetVaultId})`);

      const response = await axios.post(
        config.REACT_APP_ENV_API_BASE + `/KeyvaultControl/migrateVaultAdmin?firstVaultNm=${sourceVault}&SecondVaultNm=${targetVault}`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('login')}`,
          },
        }
      );

      console.log('Migration response:', response);
      await compareVaults();
      // if (response.status >= 200 && response.status < 300) {
      //   setStatusMessage(`Successfully migrated from ${sourceVault} to ${targetVault}`);
      //   // After successful migration, compare the vaults to show any remaining differences
      //   console.log("line300",response?.data?.data);
      //   let newResponse = response?.data?.data;
      //   let newComparisonResult: ComparisonResult = {
      //     sourceVault: sourceVault,
      //     targetVault: targetVault,
      //     missingSecrets: newResponse?.MissingKeys.map((item: { name: any; }) => item.name) || [],
      //     differentSecrets: newResponse?.DifferentKeys.map((item: { name: any; }) => item.name) || []
      //   };

      //   //setComparisonResult(newComparisonResult);
      //   console.log("line306", newComparisonResult);
      //   await compareVaults();
      // } else {
      //   throw new Error(response.data?.message || 'Migration failed');
      // }
    } catch (error: any) {
      console.error('Migration failed:', error);
    } finally {
    }
  };

  const renderComparisonResult = () => {
    if (!comparisonResult) return null;

    const { missingSecrets, differentSecrets } = comparisonResult;
    console.log('Comparison Result:', comparisonResult);
    // Mock secret values - replace with actual API call in production
    const getSecretValue = (secretName: string, type: 'current' | 'new') => {
      // In a real implementation, this would make an API call to get the actual secret value
      return type === 'current'
        ? `current-value-for-${secretName}`
        : `new-value-for-${secretName}`;
    };
    const hasMissing = missingSecrets.length > 0;
    const hasDifferent = differentSecrets.length > 0;
    const { isExpanded, isMigrating, selectedMissing, selectedDifferent } = migrationState;

    const handleCopyToClipboard = (text: string) => {
      navigator.clipboard.writeText(text);
    };

    return (
      <Card sx={{ mb: 4, borderLeft: '4px solid', borderColor: 'primary.main', position: "relative", left: "80px", width: "92%" }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            p: 2,
            cursor: 'pointer',
            '&:hover': { bgcolor: 'action.hover' }
          }}
          onClick={() => setMigrationState(prev => ({ ...prev, isExpanded: !prev.isExpanded }))}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              Env Migration Results
            </Typography>
            <Box sx={{ ml: 2, display: 'flex', gap: 1 }}>
              {hasMissing && (
                <Box sx={{
                  bgcolor: 'warning.light',
                  color: 'warning.contrastText',
                  px: 1,
                  borderRadius: 1,
                  fontSize: '0.75rem',
                  fontWeight: 'bold'
                }}>
                  {missingSecrets.length} Missing
                </Box>
              )}
              {hasDifferent && (
                <Box sx={{
                  bgcolor: 'info.light',
                  color: 'info.contrastText',
                  px: 1,
                  borderRadius: 1,
                  fontSize: '0.75rem',
                  fontWeight: 'bold'
                }}>
                  {differentSecrets.length} Different
                </Box>
              )}
            </Box>
          </Box>
          <IconButton size="small">
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>

        <Collapse in={isExpanded}>
          <CardContent>
            {(hasMissing || hasDifferent) && (
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                  Select the secrets you want to migrate
                </Typography>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleMigrateSelected}
                  disabled={
                    isMigrating ||
                    (selectedMissing.length === 0 && selectedDifferent.length === 0)
                  }
                  startIcon={
                    isMigrating ? <CircularProgress size={16} color="inherit" /> : <CompareArrowsIcon />
                  }
                  sx={{
                    mb: 2,
                    color: '#734bd1',
                    borderColor: '#734bd1',
                    '&:hover': {
                      backgroundColor: '#f4efff',
                      borderColor: '#5e3fb0',
                      color: '#5e3fb0',
                    },
                    '&.Mui-disabled': {
                      borderColor: '#e0e0e0',
                      color: '#aaa',
                    },
                  }}
                >
                  {isMigrating ? 'Migrating...' : 'Migrate Selected'}
                </Button>
              </Box>
            )}

            {hasMissing && (
              <Box sx={{ mb: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                    Missing Secrets
                  </Typography>
                  <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                    (Secrets that exist in source but not in target)
                  </Typography>
                </Box>
                <TableContainer component={Paper} variant="outlined">
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell padding="checkbox">Select</TableCell>
                        <TableCell>Secret Name</TableCell>
                        <TableCell>Value</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {missingSecrets.map((secret) => {
                        const secretObj = missingvaults.find(item => item.name === secret); const secretValue = secretObj?.value || 'N/A'; return (
                          <TableRow key={`missing-${secret}`} hover>
                            <TableCell padding="checkbox">
                              <Checkbox
                                sx={{
                                  color: '#734bd1',
                                  '&.Mui-checked': {
                                    color: '#734bd1',
                                  },
                                  '&.MuiCheckbox-indeterminate': {
                                    color: '#734bd1',
                                  },
                                  '&.Mui-disabled': {
                                    color: '#c7b7ec',
                                  },
                                }}
                                checked={selectedMissing.includes(secret)}
                                onChange={(e) => {
                                  setMigrationState(prev => ({
                                    ...prev,
                                    selectedMissing: e.target.checked
                                      ? [...prev.selectedMissing, secret]
                                      : prev.selectedMissing.filter(s => s !== secret)
                                  }));
                                }}
                              />
                            </TableCell>
                            <TableCell>{secret}</TableCell>
                            {editingMissingSecret === secret ? (
                              <>
                                <TableCell>
                                  <TextField
                                    fullWidth
                                    size="small"
                                    value={inlineMissingValue}
                                    onChange={(e) => setInlineMissingValue(e.target.value)}
                                  />
                                </TableCell>
                                <TableCell>
                                  <Box sx={{ display: 'flex', gap: 1 }}>
                                    <Button
                                      size="small"
                                      variant="contained"
                                      onClick={handleUpdateMissingSecret}
                                      disabled={!inlineMissingValue.trim()}
                                    >
                                      Save
                                    </Button>
                                    <Button
                                      size="small"
                                      variant="outlined"
                                      onClick={handleCancelMissingEdit}
                                    >
                                      Cancel
                                    </Button>
                                  </Box>
                                </TableCell>
                              </>
                            ) : (
                              <>
                                <TableCell>
                                  {viewedSecrets[`missing-${secret}`] ? secretValue : '••••••••'}
                                </TableCell>
                                <TableCell>
                                  <Tooltip title={viewedSecrets[`missing-${secret}`] ? 'Hide' : 'View'}>
                                    <IconButton size="small" onClick={(e) => { e.stopPropagation(); toggleViewSecret(`missing-${secret}`); }}>
                                      {viewedSecrets[`missing-${secret}`] ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="Copy to clipboard">
                                    <IconButton size="small" onClick={(e) => { e.stopPropagation(); navigator.clipboard.writeText(secretValue); }}>
                                      <CopyIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="Edit value">
                                    <IconButton size="small" onClick={() => handleStartMissingEdit(secret)} sx={{ color: "#734bd1" }} >
                                      <EditIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </TableCell>
                              </>
                            )}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}

            {hasDifferent && (
              <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                    Different Secrets
                  </Typography>
                  <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                    (Secrets that exist in both but have different values)
                  </Typography>
                </Box>
                <TableContainer component={Paper} variant="outlined">
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell padding="checkbox">
                          <Checkbox
                            sx={{
                              color: '#734bd1',
                              '&.Mui-checked': {
                                color: '#734bd1',
                              },
                              '&.MuiCheckbox-indeterminate': {
                                color: '#734bd1',
                              },
                              '&.Mui-disabled': {
                                color: '#c7b7ec',
                              },
                            }}
                            checked={differentSecrets.length > 0 &&
                              selectedDifferent.length === differentSecrets.length}
                            indeterminate={selectedDifferent.length > 0 &&
                              selectedDifferent.length < differentSecrets.length}
                            onChange={(e) => {
                              // Only allow selecting all if not already in partial selection state
                              if (e.target.checked) {
                                setMigrationState(prev => ({
                                  ...prev,
                                  selectedDifferent: [...differentSecrets]
                                }));
                              } else {
                                setMigrationState(prev => ({
                                  ...prev,
                                  selectedDifferent: []
                                }));
                              }
                            }}
                            disabled={selectedDifferent.length > 0 &&
                              selectedDifferent.length < differentSecrets.length}
                          />
                        </TableCell>
                        <TableCell>Secret Name</TableCell>
                        <TableCell>Current Value</TableCell>
                        <TableCell>New Value</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {differentSecrets.map((secret) => (
                        <TableRow key={`diff-${secret}`} hover>
                          <TableCell padding="checkbox">
                            <Checkbox
                              sx={{
                                color: '#734bd1',
                                '&.Mui-checked': {
                                  color: '#734bd1',
                                },
                                '&.MuiCheckbox-indeterminate': {
                                  color: '#734bd1',
                                },
                                '&.Mui-disabled': {
                                  color: '#c7b7ec',
                                },
                              }}
                              checked={selectedDifferent.includes(secret)}
                              onChange={(e) => {
                                setMigrationState(prev => ({
                                  ...prev,
                                  selectedDifferent: e.target.checked
                                    ? [...prev.selectedDifferent, secret]
                                    : prev.selectedDifferent.filter(s => s !== secret)
                                }));
                              }}
                            />
                          </TableCell>
                          <TableCell>{secret}</TableCell>
                          <TableCell>
                            <Box sx={{
                              fontFamily: 'monospace',
                              bgcolor: 'rgba(0, 0, 0, 0.04)',
                              p: 0.5,
                              borderRadius: 0.5,
                              fontSize: '0.8rem',
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              minWidth: '200px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis'
                            }}>
                              {viewedSecrets[`current-${secret}`] ? (
                                <>
                                  {differentVaults.find(item => item.name === secret)?.firstValue || 'N/A'}
                                  <Tooltip title="Hide">
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        toggleViewSecret(`current-${secret}`);
                                      }}
                                      sx={{ p: 0.5, ml: 'auto' }}
                                    >
                                      <VisibilityOffIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </>
                              ) : (
                                <>
                                  <span>••••••••</span>
                                  <Tooltip title="View">
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        toggleViewSecret(`current-${secret}`);
                                      }}
                                      sx={{ p: 0.5, ml: 'auto' }}
                                    >
                                      <VisibilityIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </>
                              )}
                              <Tooltip title="Copy to clipboard">
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleCopyToClipboard(getSecretValue(secret, 'current'));
                                  }}
                                  sx={{ p: 0.5 }}
                                >
                                  <CopyIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box sx={{
                              bgcolor: "#e0d5fc",
                              fontFamily: 'monospace',
                              p: 0.5,
                              borderRadius: 0.5,
                              fontSize: '0.8rem',
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              minWidth: '200px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis'
                            }}>
                              {viewedSecrets[`new-${secret}`] ? (
                                <>
                                  {differentVaults.find(item => item.name === secret)?.secondValue || 'N/A'}
                                  <Tooltip title="Hide">
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        toggleViewSecret(`new-${secret}`);
                                      }}
                                      sx={{ p: 0.5, ml: 'auto' }}
                                    >
                                      <VisibilityOffIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </>
                              ) : (
                                <>
                                  <span>••••••••</span>
                                  <Tooltip title="View">
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        toggleViewSecret(`new-${secret}`);
                                      }}
                                      sx={{ p: 0.5, ml: 'auto' }}
                                    >
                                      <VisibilityIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </>
                              )}
                              <Tooltip title="Copy to clipboard">
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleCopyToClipboard(getSecretValue(secret, 'new'));
                                  }}
                                  sx={{ p: 0.5 }}
                                >
                                  <CopyIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Tooltip title="View both values">
                              <Button
                                sx={{ color: "#734bd1", borderColor: "#734bd1" }}
                                variant="outlined"
                                size="small"
                                onClick={() => {
                                  toggleViewSecret(`current-${secret}`);
                                  toggleViewSecret(`new-${secret}`);
                                }}
                                startIcon={<VisibilityIcon />}
                              >
                                {viewedSecrets[`current-${secret}`] && viewedSecrets[`new-${secret}`]
                                  ? 'Hide All'
                                  : 'View All'}
                              </Button>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}

            {!hasMissing && !hasDifferent && (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <CheckIcon color="success" sx={{ fontSize: 48, mb: 2 }} />
                <Typography variant="h6" gutterBottom>
                  Vaults are in sync!
                </Typography>
                <Typography color="text.secondary">
                  No differences found between the source and target vaults.
                </Typography>
              </Box>
            )}
          </CardContent>
        </Collapse>
      </Card>
    );
  };

  return (
    <Box sx={{ height: "100px" }}>
      {renderComparisonResult()}
    </Box>
  );
};



export default MigrationToolEnv;
